module.exports = __webpack_public_path__ + "img/fcdf5bc.jpg";